import React from "react";
import { withStyles, LinearProgress } from "@material-ui/core/";
import { Greetings } from "aws-amplify-react";
import {
  NavBar,
  Nav,
  NavRight,
} from "aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React";

const LoginLinearProgress = withStyles((theme) => ({
  root: {
    height: 15,
    borderRadius: 5,
  },
  colorPrimary: {
    backgroundColor: "#F7EEE3",
  },
  bar: {
    borderRadius: 5,
    backgroundColor: "#F59220",
  },
}))(LinearProgress);

export class MyGreetings extends Greetings {
  constructor(props) {
    super(props);
    // console.log(props);
  }

  render() {
    const authState = this.props.authState || this.state.authState;
    const signedIn = authState === "signedIn";
    // console.log(authState, signedIn);
    const theme = this.props.theme;
    const greeting = signedIn
      ? this.userGreetings(theme)
      : this.noUserGreetings(theme);
    if (!greeting) {
      return null;
    }

    return (
      <NavBar theme={theme}>
        <Nav theme={theme}>
          <NavRight theme={theme}>
            <LoginLinearProgress />
          </NavRight>
          {/* <NavRight theme={theme}>{greeting}</NavRight> */}
        </Nav>
      </NavBar>
    );
  }
}
